import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loading = () => {
  const spinnerContainerStyle = {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
  
  return (
    <div style={spinnerContainerStyle}>
      <Spinner animation="border" />
    </div>
  );
};

export default Loading;
